<p-table
  class="height100"
  #turboTable
  [value]="getValues(classes, sections, i)"
  styleClass="p-datatable-striped p-datatable-gridlines"
  class="ui-g-{{ 12 / sections }} height100 table-result"
  [resizableColumns]="true"
  [scrollable]="true"
>
  <ng-template pTemplate="header">
    <tr>
      <th pFrozenColumn class="lap_header" [ngClass]="{ basis170: minimize, basis270: !minimize }">
        <span class="lap_number">
         {{ appSettings.translate[selectedLang]['FIO'] }}
        </span>
      </th>
      <th *ngFor="let col of scrollableCols" class="lap_header basis100">
        <span class="{{ col.lap !== undefined ? 'lap_number' : '' }}">
          <!-- {{ col.header_index ? appSettings.translate[selectedLang][col.header_index] : col.header }} -->
          {{ col.lap !== undefined ? col.lap + 1 : '' }}
        </span>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr *ngIf="scrollableCols.length" class="race_class">
      <td pFrozenColumn [colSpan]="scrollableCols.length">
        <span>
          <a href="#" (click)="showInfoClass(rowData)">
            <b>{{ appSettings.translate[selectedLang]['class'] }}:</b>
            {{ rowData.class.name }}
            <span *ngIf="rowData.class.raceTime">&nbsp;<b></b>{{ rowData.class.raceTime }} мин.</span>
            <span *ngIf="rowData.class.raceTime && rowData.class.raceLaps > 0">&nbsp;+{{ rowData.class.raceLaps }} круг(ов)</span>
            <span *ngIf="!rowData.class.raceTime && rowData.class.raceLaps > 0">{{ rowData.class.raceLaps }} круг(ов)</span>
          </a>
        </span>
      </td>
    </tr>
    <tr
      *ngFor="let competitor of rowData.registrations"
      class="row_table"
      #competitorrow
      [attr.id]="competitor.registration.startNumber"
      [ngClass]="{ die: competitor.DNF > 0 }"
    >
      <td
        pFrozenColumn
        [ngClass]="{ text_overflow: true }"
        class="competitor"
        style="padding: 10px"
        [ngClass]="{ basis170: minimize, basis270: !minimize }"
        (click)="clickInfo(competitor.registration.user.cUid)"
      >
        <app-competitor-info
          [competitor]="competitor"
          [TVResume]="TVResume"
          [selectedRace]="selectedRace"
          [minimize]="minimize"
        ></app-competitor-info>
        <br>
      </td>
      <td
        *ngFor="let col of scrollableCols"
        class="lap_row basis100"
        [ngClass]="{
          toTop: true,
          dsq_0: competitor.laps[col.lap] && competitor.laps[col.lap].DSQ === 0,
          dsq_1: competitor.laps[col.lap] && competitor.laps[col.lap].DSQ !== 0,
          best_lap: competitor.laps[col.lap] && col.lap == competitor.bestLap - 1,
          clickable: competitor.laps[col.lap]
        }"
        (click)="clickLap(competitor.laps[col.lap], competitor.laps.indexOf(competitor.laps[col.lap]), competitor)"
      >
        <div *ngIf="competitor.laps[col.lap]">
          <app-marks-table
            [marks]="competitor.laps[col.lap].marks"
            [time_state]="time_state"
            [TVResume]="TVResume"
            [selectedRace]="selectedRace"
            [competitor]="competitor"
            [col]="col"
          ></app-marks-table>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- Диалог с данными о параметрах класса -->
<p-dialog
  *ngIf="infoClassModal"
  header="{{ appSettings.translate[selectedLang]['lapParams'] }} '{{ infoClassModalData.class.name }}'"
  [(visible)]="infoClassModal"
  [contentStyle]="{
    'overflow-y': 'scroll',
    'max-height': 'calc(100vh - 46px)',
    'min-height': '200px',
    'max-width': '650px'
  }"
  [positionTop]="0"
  [responsive]="false"
  [breakpoint]="640"
  [draggable]="false"
  [modal]="true"
  [blockScroll]="true"
  appendTo="body"
>
  <div class="ui-g-12">
    <p-fieldset legend="{{ appSettings.translate[selectedLang]['laps'] }}:" class="ui-g-3 ui-sm-6 ui-g-nopad center">
      {{ infoClassModalData.class.raceLaps }}
    </p-fieldset>
    <p-fieldset legend="{{ appSettings.translate[selectedLang]['time'] }}:" class="ui-g-3 ui-sm-6 ui-g-nopad center">
      <span *ngIf="infoClassModalData.class.raceTime">{{ infoClassModalData.class.raceTime | timePeriodPipe : 'HH:mm:ss' }}</span>
      <span *ngIf="!infoClassModalData.class.raceTime">--:--:--</span>
    </p-fieldset>
    <p-fieldset legend="{{ appSettings.translate[selectedLang]['finishAfterLeader'] }}:" class="ui-g-6 ui-sm-12 ui-g-nopad center">
      <span *ngIf="infoClassModalData.class.flFinishAllAfterLeader"><i class="pi pi-check"></i> {{ appSettings.translate[selectedLang]['finishing'] }}</span>
      <span *ngIf="!infoClassModalData.class.flFinishAllAfterLeader"
        ><i class="pi pi-times"></i> {{ appSettings.translate[selectedLang]['isntfinishing'] }}</span
      >
    </p-fieldset>
  </div>
  <div class="ui-g-12">
    <p-fieldset legend="{{ appSettings.translate[selectedLang]['lapsComment'] }}:" class="ui-g-12 ui-g-nopad">
      <div class="ui-g-12 ui-g-nopad" *ngFor="let mark of infoClassModalData.marks">
        <div class="ui-g-2">{{ mark.marshal }}</div>
        <div class="ui-g-10" *ngIf="mark.joker">
          {{ appSettings.translate[selectedLang]['joker'] }}
          {{ appSettings.translate[selectedLang]['jokerInfo'] }}
        </div>
        <div class="ui-g-10" *ngIf="mark.marshal === 0">
          {{ appSettings.translate[selectedLang]['lapFinished'] }}
        </div>
        <div class="ui-g-10" *ngIf="mark.penaltyTime && !mark.enterMark">
          ({{ appSettings.translate[selectedLang]['fine'] }} - {{ mark.penaltyTime }})
        </div>
        <div class="ui-g-10" *ngIf="mark.enterMark">
          ({{ appSettings.translate[selectedLang]['serviceTime'] }}: {{ mark.minTime }},
          {{ appSettings.translate[selectedLang]['maxTime'] }}: {{ mark.maxTime }})
          <span *ngIf="mark.penaltyTime">({{ appSettings.translate[selectedLang]['fine'] }} - {{ mark.penaltyTime }})</span>
        </div>
        <div class="ui-g-12 ui-g-nopad">
          <hr />
        </div>
      </div>
    </p-fieldset>
  </div>
</p-dialog>

<!-- Диалог с объяснением нарушений на круге -->
<p-dialog
  *ngIf="infoLapModal && infoLapModalData.lap.penalty"
  header="{{ appSettings.translate[selectedLang]['infoErrors'] }} {{ infoLapModalData.indexLap + 1 }} {{
    appSettings.translate[selectedLang]['FIO1']
  }} {{ infoLapModalData.competitor.registration.user.name }}"
  [(visible)]="infoLapModal"
  [contentStyle]="{
    overflow: 'scroll',
    'max-height': 'calc(100vh - 46px)',
    'min-height': '250px',
    'max-width': '650px'
  }"
  [positionTop]="0"
  [responsive]="false"
  [breakpoint]="640"
  [draggable]="false"
  [modal]="true"
  [blockScroll]="true"
  appendTo="body"
>
  <div class="ui-g-12 ui-g-nopad" *ngFor="let penal of infoLapModalData.lap.penalty">
    <div class="ui-g-10">{{ penal.text }}</div>
    <div class="ui-g-2">{{ penal.time }}</div>
    <div class="ui-g-12 ui-g-nopad">
      <hr />
    </div>
  </div>
</p-dialog>
